export default __webpack_public_path__ + "static/media/sticker-E.adb0be52.png";